module.exports = __webpack_public_path__ + "static/myob-video-fdfadf014192d04a04b445540906c940.png";